import { useState } from "react";
import { motion } from "framer-motion";
import freeCodeCamp from "../../../Assets/Images/Certificates/freeCodeCamp-Responsive webdesign.png";
import GDSC_Weeks_bootcamp from "../../../Assets/Images/Certificates/GDSC-3 Weeks Bootcamp.jpg";
import NH from "../../../Assets/Images/Certificates/New Horizon Certificate.jpg";
import GL_Firewall from "../../../Assets/Images/Certificates/Great Learning - Firewall.png";
import GDSC_Days_challenge from "../../../Assets/Images/Certificates/GDSC-30 Days of Learning Challenge .jpg";
import GL_NS from "../../../Assets/Images/Certificates/Great Learning - Network Security .png";
import SL_js from "../../../Assets/Images/Certificates/SoloLearn-JavaScript.jpg";
import GL_Rjs from "../../../Assets/Images/Certificates/Great Learning React JS course.png";
import SL_WebDev from "../../../Assets/Images/Certificates/SoloLearn-Web Development.jpg";
import SL_SQL from "../../../Assets/Images/Certificates/SoloLearn-SQL.png";
import SkillUp from "../../../Assets/Images/Certificates/SkillUp(SimpliLearn)-React Js Course.png";
import scalar from "../../../Assets/Images/Certificates/Scaler - React JS.png";
import SectionHeading from "../../SectionHeading";
import { fadeUp, stagger } from "../../motion";
import "../../css/CertGallery.css";

const CERTS = [
  { name: "freeCodeCamp — Responsive Web Design", img: freeCodeCamp },
  { name: "GDSC — 3 Weeks Bootcamp", img: GDSC_Weeks_bootcamp },
  { name: "New Horizon Certificate", img: NH },
  { name: "Great Learning — Firewall", img: GL_Firewall },
  { name: "GDSC — 30 Days of Learning", img: GDSC_Days_challenge },
  { name: "Great Learning — Network Security", img: GL_NS },
  { name: "SoloLearn — JavaScript", img: SL_js },
  { name: "Great Learning — React JS", img: GL_Rjs },
  { name: "SoloLearn — Web Development", img: SL_WebDev },
  { name: "SoloLearn — SQL", img: SL_SQL },
  { name: "SimpliLearn — React JS", img: SkillUp },
  { name: "Scaler — React JS", img: scalar },
];

const INITIAL_COUNT = 6;

const CertGallery = () => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? CERTS : CERTS.slice(0, INITIAL_COUNT);

  return (
    <section className="section certs">
      <div className="container">
        <SectionHeading
          eyebrow="Certificates"
          title="Professional certificate gallery"
          subtitle="A selection of certifications earned throughout my professional journey."
        />

        <motion.div
          className="certs__grid"
          variants={stagger}
          initial="hidden"
          animate="visible"
        >
          {visible.map((cert) => (
            <motion.figure key={cert.name} className="cert-card" variants={fadeUp}>
              <img src={cert.img} alt={cert.name} loading="lazy" />
              <figcaption>{cert.name}</figcaption>
            </motion.figure>
          ))}
        </motion.div>

        {CERTS.length > INITIAL_COUNT && (
          <div className="certs__cta">
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Show less" : "Show all certificates"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default CertGallery;
